import angular from 'angular';
import CommonHttpProvider from './provider/common-http';
import BasicAuthInterceptor from './service/basic-auth-interceptor';
import HttpCacheFactory from './service/http-cache-factory';
import CommonHttpFactory from './service/common-http-factory';

import payseraConfig from '@root/assets/js/module/paysera-config/app';

angular
    .module('paysera.http', [
        payseraConfig
    ])
    .provider('commonHttp', CommonHttpProvider)
    .service('basicAuthInterceptor', BasicAuthInterceptor)
    .service('httpCacheFactory', HttpCacheFactory)
    .service('commonHttpFactory', CommonHttpFactory)
;

export default 'paysera.http';
